import { createAsyncThunk } from "@reduxjs/toolkit";

import { AppState } from "@/redux/store/store";
import { getPinDetails } from "@/models";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

let fetchPinController = new AbortController();

export const page_size = 50;

export const fetchPinDetails = createAsyncThunk(
  "places/fetchPinDetails",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      filter: string;
      filterable: boolean;
      filters: any;
      pagination: { page_size: number; page: number };
      config?: object;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { baseUrl } = adapter.adapter;
    const {
      projectId,
      placesId,
      filter = "other_users",
      filterable = true,
      filters = { sort: { created_at: "desc" } },
      pagination = { page_size, page: 1 }
    } = params;

    if (fetchPinController) {
      fetchPinController.abort();
    }

    fetchPinController = new AbortController();

    const { token } = fetchAuthToken(getState());

    const { place } = getState() as AppState;
    const { currentMapBounds: bounds } = place;

    const signal = fetchPinController.signal;

    const config = {
      signal
    };

    try {
      const userResponse = await getPinDetails(
        token,
        baseUrl,
        projectId,
        placesId,
        { filter, filterable, filters, ...pagination, ...bounds },
        config
      );

      return userResponse;
    } catch (error) {
      if (signal.aborted) {
        return rejectWithValue("aborted");
      }

      return rejectWithValue(error);
    }
  }
);

export const fetchPaginatedPins = createAsyncThunk(
  "places/fetchPaginatedPins",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      filter: string;
      filterable: boolean;
      filters: any;
      pagination: { page_size: number; page: number };
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;

    const { baseUrl } = adapter.adapter;
    const {
      projectId,
      placesId,
      filter = "other_users",
      filterable = true,
      filters = { sort: { created_at: "desc" } },
      pagination = { page_size, page: 1 }
    } = params;

    const { token } = fetchAuthToken(getState());

    const { place } = getState() as AppState;
    const { currentMapBounds: bounds } = place;

    if (fetchPinController) {
      fetchPinController.abort();
    }

    fetchPinController = new AbortController();
    const signal = fetchPinController.signal;

    const config = {
      signal
    };

    try {
      const userResponse = await getPinDetails(
        token,
        baseUrl,
        projectId,
        placesId,
        { filter, filterable, filters, ...pagination, ...bounds },
        config
      );

      return userResponse;
    } catch (error) {
      if (signal.aborted) {
        return rejectWithValue("aborted");
      }

      return rejectWithValue(error);
    }
  }
);
